import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ResetShipmentServiceRequest } from 'app/generated/backend/shipment/api/reset-shipment-service-request';
import { ResetShipmentServiceResponse } from 'app/generated/backend/shipment/api/reset-shipment-service-response';

@Injectable()
export class ResetShipmentServiceHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: ResetShipmentServiceRequest
	): Observable<JsonResourceResponse<ResetShipmentServiceResponse>> {
		return this.http.post<JsonResourceResponse<ResetShipmentServiceResponse>>('api/v1/shipment/resetShipmentService', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ResetShipmentServiceHandlerService
	]
})
export class ResetShipmentServiceHandlerModule { }
